





















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import {
	decimal,
	integer,
	maxValue,
	minValue,
	required,
	requiredIf,
} from 'vuelidate/lib/validators';
import secondaryNav from '@/components/navbars/secondary-nav.vue';

import {
	Product,
	Sensor,
	TanksApi,
	WaterMeterInfo,
	WaterMetersApi,
	WaterMonitorInfo,
	WaterMonitorsApi,
	WaterTank,
	WaterMeter,
	WaterMonitor,
	WaterTankInfo,
	WaterTanksApi,
	Transceiver,
	EntityLocation,
} from '@/api';
import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import Toast from '@/components/display/toast.vue';
import LocationInput from '@/components/form pickers/LocationInput.vue';
import { Constants } from '@/common/Constants';
import { EntityLocationService } from '@/services/entity-location-service';
import { WaterEntityUtil } from '@/common/WaterEntityUtil';
import NodeSuggest from '@/components/form pickers/nodeSuggest.vue';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: {
		SaveCancelButtons,
		NodeSuggest,
		LocationInput,
		secondaryNav,
		TransceiverSuggest,
		SensorSuggest,
		Toast,
	},
	validations: {
		entity: {
			transceiver: { required },
			sensor: {
				required: requiredIf(function() {
					return (
						this.entityType === 'water_tanks' ||
						this.isItAClassicTransceiver(this.entity.transceiver)
					);
				}),
				node: {},
			},
		},
	},
	mixins: [validationMixin],
})
export default class WaterEntityInstallModal extends Vue {
	@Prop(Object)
	public entity: WaterTank | WaterMeter | WaterMonitor | undefined;

	@Prop(String)
	public entityType: string | undefined;

	@Prop(String)
	public modalType: string | undefined;

	public transceiverId: number = 0;

	public loading = false;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;

	public validations = this.$options.validations;
	public classicTransceiver = false;
	private waterMetersApi: WaterMetersApi = new WaterMetersApi();
	private waterTanksApi: WaterTanksApi = new WaterTanksApi();
	private waterMonitorsApi: WaterMonitorsApi = new WaterMonitorsApi();

	private toast: Toast = new Toast();

	public updated() {
		this.isItAClassicTransceiver(this.entity.transceiver);
	}

	public isItAClassicTransceiver(transceiver: Transceiver) {
		if (transceiver) {
			this.classicTransceiver =
				transceiver.type === null
					? false
					: ['00', '03', '04'].includes(transceiver.type.toString()) &&
					  transceiver.principalId === null;
		}
		if (this.classicTransceiver) {
			this.entity.sensor = null;
		}
	}

	public async installEntity() {
		this.$v.entity.$touch();

		if (this.$v.entity.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}

		this.submitStatus = 'PENDING';

		let entityType = this.entityType;
		let entityId = this.entity.id;
		let data = {
			transceiverId: this.entity.transceiver.id,
			sensorId: this.entity.sensor != null ? parseInt(this.entity.sensor.id, 10) : null,
			entityType: entityType,
			nodeId: this.entity.sensor?.node?.id ?? null,
		};

		if (this.entityType === 'meter' && this.isItAClassicTransceiver(data.transceiver)) {
			entity.sensor = null;
		}

		try {
			const id = parseInt(entityId, 10);

			switch (entityType) {
				case 'water_meters':
					await this.waterMetersApi.installWaterMeter(id, { data: data });
					break;
				case 'water_tanks':
					await this.waterTanksApi.installWaterTank(id, { data: data });
					break;
				case 'water_monitors':
					await this.waterMonitorsApi.installWaterMonitor(id, { data: data });
					break;
			}
		} catch (e) {
			let error;
			if (e.response) {
				error =
					this.entityType + ' not installed ' + JSON.stringify(e.response.data.errors, null, 2);
			} else if (e.request) {
				error = this.entityType + ' not installed, network Error';
			} else {
				error = this.entityType + ' not installed, unknown Error';
			}
			new Toast().makeToast(error, 'Error Installing Water ' + this.entityType, 'danger', false);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast(
			'Successfully Allocated Water ' + this.entityType,
			'Successful Allocation',
			'success',
			false,
		);
		this.cancel();
	}

	public cancel() {
		this.$emit('loadEntity');
		this.submitStatus = 'OK';
		this.$bvModal.hide(`${this.modalType}Modal${this.entity.id}`);
	}

	private isEditModal(): boolean {
		return this.modalType && this.modalType.toLowerCase().startsWith('change');
	}
}
